import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { AuthorizedOwner, ConfirmDelete } from "MODULES/shared/components";
import { deleteIncomingQuote } from "../actions";

function DeleteIncomingQuote({ incomingQuote, destroy }) {
  return (
    <AuthorizedOwner record={incomingQuote}>
      <li className="divider" />
      <ToggleSwitch>
        {(visible, open, close) => (
          <DropDownItem onClick={open}>
            <span className="text-danger">
              <i className="fa fa-fw fa-ban" />{" "}
              <span>Delete Incoming Quote</span>
            </span>
            <ConfirmDelete onConfirm={destroy} close={close} open={visible}>
              <strong>Heads up!</strong> Are you sure you want to delete this?
            </ConfirmDelete>
          </DropDownItem>
        )}
      </ToggleSwitch>
    </AuthorizedOwner>
  );
}

export default connect(undefined, { destroy: deleteIncomingQuote })(
  DeleteIncomingQuote
);

DeleteIncomingQuote.propTypes = {
  incomingQuote: PropTypes.instanceOf(Map),
  destroy: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/DeleteIncomingQuote.jsx